import { TInventory } from "./inventory";
import { TLocation } from "./location";
import { TUser } from "./user";

export enum LocationAuditStatus {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export type TLocationAuditItem = {
  id: string;
  auditId: string;
  inventoryId: string;
  inventory: TInventory;
  isConfirmed: boolean;
  wasAdded: boolean;
  confirmedAt: string | null;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
};

export type TLocationAudit = {
  id: string;
  locationId: string;
  location: TLocation;
  userId: string;
  user: TUser;
  status: LocationAuditStatus;
  startedAt: string;
  completedAt: string | null;
  notes: string | null;
  items: TLocationAuditItem[];
  createdAt: string;
  updatedAt: string;
};

export type CreateLocationAuditDto = {
  locationId: string;
  userId: string;
  notes?: string;
};

export type UpdateLocationAuditDto = {
  status?: LocationAuditStatus;
  notes?: string;
};

export type CompleteLocationAuditDto = {
  notes?: string;
};

export type AddAuditItemDto = {
  inventoryId: string;
  wasAdded?: boolean;
  notes?: string;
};

export type BulkAddAuditItemsDto = {
  inventoryIds: string[];
  wasAdded?: boolean;
};

export type UpdateAuditItemDto = {
  isConfirmed?: boolean;
  notes?: string;
};
